module.exports = __webpack_public_path__ + "img/facebook1.ea916774.png";